export const registerServiceWorker = () => {
    if('serviceWorker' in navigator) {
        navigator.serviceWorker.register('firebase-messaging-sw.js')
        .then(reg => reg.scope)
        .catch(e => e)
    }
}